export default {"src":"/_next/static/media/shipandstorage.17b02ef2.svg","height":74,"width":160,"blurWidth":0,"blurHeight":0};